import { render } from "./DragonstwoView.vue?vue&type=template&id=649dfce2"
import script from "./DragonstwoView.vue?vue&type=script&lang=js"
export * from "./DragonstwoView.vue?vue&type=script&lang=js"

import "./DragonstwoView.vue?vue&type=style&index=0&id=649dfce2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__